import type { CSSProperties } from 'react';
import { tokens } from '@fluentui/react-components';

export const STEP_MARKER_SIZE = 26;

const filled = (color: string): CSSProperties => ({
  backgroundColor: color,
  border: `2px solid ${color}`,
  color: tokens.colorNeutralForegroundOnBrand,
});

const upcoming: CSSProperties = {
  backgroundColor: tokens.colorNeutralBackground1,
  border: `2px solid ${tokens.colorNeutralStroke1}`,
  color: tokens.colorNeutralForeground3,
};

const activeRing: CSSProperties = {
  boxShadow: `0 0 0 4px color-mix(in srgb, ${tokens.colorBrandBackground} 18%, transparent)`,
};

export const stepMarkerStyle = (
  isActive: boolean,
  isCompleted: boolean
): CSSProperties => ({
  width: STEP_MARKER_SIZE,
  height: STEP_MARKER_SIZE,
  borderRadius: '50%',
  flexShrink: 0,
  boxSizing: 'border-box',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: tokens.fontSizeBase200,
  fontWeight: tokens.fontWeightSemibold,
  ...(isCompleted
    ? filled(tokens.colorPaletteGreenBackground3)
    : isActive
    ? filled(tokens.colorBrandBackground)
    : upcoming),
  ...(isActive ? activeRing : {}),
});

export const stepLabelColor = (isActive: boolean): string =>
  isActive ? tokens.colorNeutralForeground1 : tokens.colorNeutralForeground3;
